// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { carouselStyles } from "@vanmeter/Overrides/Components/ProductCompareCarousel";
import { fontConfig } from "@vanmeter/XDL/constants";
import { ellipsis, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.attributeValueText = {
    ellipsis: true,
    variant: "p",
    forwardAs: "p",
    css: css`
        &&&& {
            padding: 4px;
            margin-bottom: 0;
            text-align: center;
            white-space: normal;
            word-break: break-word;
            ${ellipsis(1)}
        }
    `,
};

carouselStyles.attributeLabelText = {
    ...carouselStyles.attributeValueText,
    weight: fontConfig.weight.bold,
    css: css`
        ${carouselStyles.attributeValueText.css}
        text-align: start;
    `,
};

carouselStyles.carouselWrapper = {
    css: css`
        width: 100%;
        position: relative;
        .slideContainer {
            padding: 0 6px;
        }
    `,
};

carouselStyles.attributeValuesWrapper = {
    css: css`
        width: 100%;
        position: relative;
    `,
};

carouselStyles.Wrapper = {
    css: css`
        width: 100%;
        flex-direction: column;
    `,
};

carouselStyles.titleText = {
    variant: "h1",
    css: css`
        text-align: start;
    `,
};

carouselStyles.nextArrowGridItem = {
    width: [0, 0, 0, 1, 1],
    css: css`
        justify-content: flex-end;
        &&& button {
            right: unset;
        }
    `,
};

carouselStyles.prevArrowGridItem = {
    width: [0, 0, 0, 1, 1],
    css: css`
        &&& button {
            left: unset;
        }
    `,
};

carouselStyles.carouselGridItem = {
    width: [12, 12, 12, 10, 10],
};

carouselStyles.carouselContentEmptyCellGridItem = {
    width: [0, 4, 4, 4, 4],
};

carouselStyles.carouselCellGridItem = {
    width: [12, 12, 8, 8, 8],
};

carouselStyles.attributeLabelsCellGridItem = {
    width: [6, 4, 4, 4, 4],
    css: css`
        padding-top: 20px;
    `,
};

carouselStyles.attributeValuesCellGridItem = {
    width: [6, 8, 8, 8, 8],
    css: css`
        padding-top: 20px;
    `,
};

carouselStyles.attributeLabelGridItem = carouselStyles.attributeValueGridItem = {
    width: 12,
};

carouselStyles.cellStyles = {
    css: css`
        ${xScreen("lte", "md")} {
            > p:not(.attribute) {
                display: none;
            }
            p {
                width: 100%;
            }
        }
    `,
};

carouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        display: grid;
        grid-template-rows: subgrid;
        grid-row: 1 / span 10;
    `,
};
